import {ExpandMore} from '@mui/icons-material';
import {Accordion, AccordionDetails, AccordionSummary, Divider, Typography, useTheme} from '@mui/material';
import Grid from '@mui/material/Grid';
import muiStyled from '@mui/material/styles/styled';
import PropTypes, {func, oneOfType, shape} from 'prop-types';

import {FONT_FAMILIES} from '../../../../const';
import useReportParameters from '../../../../hooks/providers/useReportParameters';

const StyledAccordionTitle = muiStyled(Typography)(() => ({
  fontSize: 17,
  fontFamily: FONT_FAMILIES.TITLE,
  fontWeight: 'bold'
}));

const StyledAccordionSubtitle = muiStyled(Typography)(({theme}) => ({
  fontSize: 14,
  color: theme.palette.text.secondary
}));

const CategoryAccordion = ({id, expanded, icon, title, subtitle, renderActionsSection, children, sx, disabled}) => {
  const {setReportParametersCategoryExpanded} = useReportParameters();
  const theme = useTheme();

  const onChange = () => {
    if (disabled) return;

    setReportParametersCategoryExpanded(current => (current === id ? null : id));
  };

  return (
    <Accordion
      data-testid="category-accordion"
      elevation={0}
      expanded={expanded}
      onChange={onChange}
      sx={{
        borderRadius: 2.5,
        overflow: 'hidden',
        boxShadow: 'none',
        border: '1px solid #DEDEDE',
        mb: 3,
        '&::before': {display: 'none'},
        ...sx
      }}
    >
      <AccordionSummary
        expandIcon={disabled ? null : <ExpandMore />}
        aria-controls={title}
        id={title}
        sx={{
          px: {
            xs: theme.spacing(1),
            sm: theme.spacing(3)
          },
          background: '#F7F8FA'
        }}
      >
        <Grid container gap={2} alignItems="center">
          <Grid item>{icon}</Grid>
          <Grid item flex={1}>
            <StyledAccordionTitle>{title}</StyledAccordionTitle>
            <StyledAccordionSubtitle>{subtitle}</StyledAccordionSubtitle>
          </Grid>
          {renderActionsSection()}
        </Grid>
      </AccordionSummary>
      <Divider sx={{mb: 2, color: '#eaeaea'}} />
      <AccordionDetails>{children}</AccordionDetails>
    </Accordion>
  );
};

CategoryAccordion.propTypes = {
  sx: shape({}),
  id: PropTypes.string.isRequired,
  renderActionsSection: func.isRequired,
  icon: PropTypes.node.isRequired,
  title: oneOfType([PropTypes.string.isRequired, PropTypes.node.isRequired]),
  subtitle: PropTypes.string.isRequired,
  expanded: PropTypes.bool.isRequired,
  disabled: PropTypes.bool.isRequired,
  children: PropTypes.node.isRequired
};

export default CategoryAccordion;
